import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import api from './AxiosConfig';
import Loading from "../Loading";

const AdminRestaurantsList = ({ token, onBack, onAddRestaurant }) => {
    const [restaurants, setRestaurants] = useState([]);
    const [error, setError] = useState(null);
    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [loading, setLoading] = useState(false);

    const fetchRestaurants = async () => {
        setLoading(true);
        try {
            const response = await api.get(`${baseUrl}/api/admin/restaurants`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setRestaurants(response.data);
            setError(null);
        } catch (err) {
            setError('Błąd podczas pobierania restauracji');
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchRestaurants();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box>
            <Loading open={loading} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button onClick={onBack} variant="outlined">
                    Powrót
                </Button>
                <Button onClick={onAddRestaurant} variant="contained">
                    Dodaj Restaurację
                </Button>
            </Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Lista Restauracji
            </Typography>
            {error && <Typography color="error">{error}</Typography>}
            {restaurants.map((restaurant) => (
                <Paper key={restaurant.id} sx={{ p: 2, mb: 2 }}>
                    <Typography variant="h6">{restaurant.name}</Typography>
                    <Typography variant="body1">Adres: {restaurant.street} {restaurant.houseNumber}</Typography>
                    <Typography variant="body1">{restaurant.postcode} {restaurant.city} </Typography>
                    <Typography variant="body1">Telefon: {restaurant.phone}</Typography>
                    <Typography variant="body1">Email: {restaurant.email}</Typography>
                    <Typography variant="body2">
                        Utworzona: {new Date(restaurant.createdAt).toLocaleString()}
                    </Typography>
                    {restaurant.users && restaurant.users.length > 0 && (
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="subtitle1">Użytkownicy:</Typography>
                            {restaurant.users.map((user) => (
                                <Typography key={user.id} variant="body2">
                                    {user.firstName} {user.lastName} ({user.username})
                                </Typography>
                            ))}
                        </Box>
                    )}
                </Paper>
            ))}
        </Box>
    );
};

export default AdminRestaurantsList;